
<template>
    <div class="json-type-com">
        <div v-if="showData.error" class="error">ERROR：无法解析的信息。</div>
        <v-table v-else-if="showData.type == 'table'" :isPage="isPage" :json="showData"></v-table>
        <div v-else class="error">ERROR：不支持的消息类型。</div>
    </div>
</template>

<script>
import Vue from "vue";
import table from "./table";

export default {
    name: "jsonType",
    props: {
        isPage: {
            type: Boolean,
            default: false,
        },
        json:{
            type: String,
            required: true,
        }
    },
    components: {
        "v-table": table,
    },
    computed: {
        showData(){
            let json = this.json;
            let obj = {};
            try {
                obj = JSON.parse(json);
            } catch (error) {
                console.log(error);
                obj = {error:true}
            }
            return obj;
        }
    },
    data() {
        return {};
    },
    beforeDestroy() {},
    created() {},
    methods: {},
};
</script>

<style lang="scss">
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
}
</style>


<style lang="scss">
.json-type-com{
    margin: 10px 0;
}
.error{
    margin: 10px 0;
    padding: 10px;
    background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/jsonType/index.vue